// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────────────────────────────────────────
   EngineerAttendance.css
   Self-contained styles for the attendance feature.
   Palette matches Engineer.css (#185fa5 primary blue).
───────────────────────────────────────────── */

.att-page {
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  color: #1a1a1a;
}

/* ── TOP BAR ── */
.att-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.25rem;
}
.att-page-title {
  font-size: 22px;
  font-weight: 600;
  letter-spacing: -0.3px;
  margin: 0 0 2px;
}
.att-page-sub {
  font-size: 13px;
  color: #6b7280;
  margin: 0;
}

/* ── ROLE TABS ── */
.att-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #e5e7eb;
}
.att-tab {
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 10px 4px;
  margin-right: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.15s;
}
.att-tab:hover { color: #185fa5; }
.att-tab.active { color: #185fa5; border-bottom-color: #185fa5; }

/* ── BUTTONS ── */
.att-btn-primary {
  background: #185fa5;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 9px 20px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
}
.att-btn-primary:hover { background: #0c447c; }
.att-btn-primary:disabled { background: #93b8d8; cursor: not-allowed; }

.att-btn-ghost {
  background: transparent;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 9px 20px;
  font-size: 13px;
  color: #374151;
  cursor: pointer;
  transition: all 0.15s;
}
.att-btn-ghost:hover { background: #f3f4f6; }
.att-btn-ghost:disabled { opacity: 0.6; cursor: not-allowed; }
.att-btn-sm { padding: 6px 14px; font-size: 12px; }

.att-btn-checkout {
  background: linear-gradient(135deg, #ef8b3b, #d9631a);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 9px 20px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}
.att-btn-checkout:hover { box-shadow: 0 6px 16px rgba(217, 99, 26, 0.3); transform: translateY(-1px); }

/* ── CHECK-IN / CHECK-OUT CARD ── */
.att-checkcard {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 1.5rem;
}
.att-checkcard-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
}
.att-checkcard-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 2px;
}
.att-checkcard-sub {
  font-size: 12.5px;
  color: #6b7280;
}
.att-checkcard-body {
  padding: 1.5rem;
}
.att-time-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 1.5rem;
}
.att-time-block {
  background: #f9fafb;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  padding: 14px 16px;
}
.att-time-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #9ca3af;
  margin-bottom: 4px;
}
.att-time-value {
  font-size: 20px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 6px;
}
.att-time-loc {
  font-size: 11.5px;
  color: #6b7280;
  line-height: 1.4;
}
.att-checkcard-actions {
  display: flex;
  justify-content: center;
}
.att-done-msg {
  font-size: 14px;
  font-weight: 500;
  color: #2e7d32;
  background: #e6f4ea;
  border-radius: 8px;
  padding: 10px 20px;
}

/* ── MODAL ── */
.att-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.att-modal {
  background: #fff;
  border-radius: 14px;
  padding: 1.5rem;
  width: 100%;
  max-width: 420px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
}
.att-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}
.att-modal-title {
  font-size: 17px;
  font-weight: 600;
  margin: 0;
}
.att-close-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #e5e7eb;
  background: transparent;
  cursor: pointer;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  transition: background 0.15s;
}
.att-close-btn:hover { background: #f3f4f6; }

.att-location-block {
  margin-bottom: 1rem;
}
.att-location-label {
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 6px;
}
.att-location-status {
  font-size: 13px;
  border-radius: 8px;
  padding: 10px 12px;
}
.att-loc-loading { background: #f3f4f6; color: #6b7280; }
.att-loc-ok { background: #eff6ff; color: #185fa5; }
.att-loc-error { background: #fff3f3; color: #e53935; display: flex; align-items: center; flex-wrap: wrap; }

.att-form-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 1rem;
}
.att-form-group label {
  font-size: 12px;
  font-weight: 500;
  color: #374151;
}
.att-form-group input {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 8px 11px;
  font-size: 13px;
  background: #f9fafb;
  color: #111827;
  outline: none;
  width: 100%;
  transition: border-color 0.15s;
}
.att-form-group input:focus { border-color: #185fa5; background: #fff; }

.att-photo-upload {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #d1d5db;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  cursor: pointer;
  font-size: 12px;
  color: #6b7280;
  background: #f9fafb;
  transition: all 0.15s;
  min-height: 80px;
}
.att-photo-upload:hover { border-color: #185fa5; color: #185fa5; background: #eff6ff; }
.att-photo-preview {
  max-width: 100%;
  max-height: 220px;
  border-radius: 6px;
  object-fit: cover;
}

.att-modal-actions {
  display: flex;
  gap: 10px;
  margin-top: 0.5rem;
}

/* ── TABLE CARDS (monthly / daily views) ── */
.att-table-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 1.5rem;
}
.att-table-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #e5e7eb;
}
.att-table-title {
  font-size: 15px;
  font-weight: 600;
}
.att-month-picker {
  display: flex;
  gap: 8px;
}
.att-month-picker select,
.att-year-input,
.att-date-input {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 7px 10px;
  font-size: 13px;
  background: #f9fafb;
  color: #111827;
  outline: none;
}
.att-year-input { width: 90px; }

.att-table {
  width: 100%;
  border-collapse: collapse;
}
.att-table th {
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 10px 1.25rem;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
}
.att-table td {
  padding: 13px 1.25rem;
  font-size: 13.5px;
  border-bottom: 1px solid #f3f4f6;
  color: #111827;
}
.att-table tbody tr:last-child td { border-bottom: none; }
.att-table tbody tr:hover td { background: #f9fafb; }
.att-muted { color: #6b7280 !important; }

.att-empty {
  text-align: center;
  padding: 3rem;
  font-size: 14px;
  color: #6b7280;
}

.att-photo-links {
  display: flex;
  gap: 10px;
}
.att-photo-links a {
  color: #185fa5;
  font-size: 12.5px;
  font-weight: 500;
  text-decoration: none;
}
.att-photo-links a:hover { text-decoration: underline; }

/* ── STAT CARDS ── */
.att-stats {
  display: grid;
  gap: 12px;
  padding: 1.25rem;
}
.att-stats-5 { grid-template-columns: repeat(5, 1fr); }
.att-stat-card {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 0.9rem 1rem;
}
.att-stat-label {
  font-size: 11px;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}
.att-stat-value { font-size: 24px; font-weight: 600; color: #111827; }
.att-stat-green { color: #3b6d11; }
.att-stat-amber { color: #b45309; }
.att-stat-red { color: #dc2626; }

/* ── SUMMARY PILLS (self monthly view) ── */
.att-summary-row {
  display: flex;
  gap: 12px;
  padding: 1.25rem 1.25rem 0;
}
.att-summary-pill {
  flex: 1 1;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px 16px;
  font-size: 12.5px;
  color: #6b7280;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.att-summary-pill span {
  font-size: 22px;
  font-weight: 600;
  color: #111827;
}
.att-pill-green span { color: #3b6d11; }
.att-pill-red span { color: #dc2626; }

/* ── DAY GRID (calendar-style status cells) ── */
.att-day-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(64px, 1fr));
  gap: 8px;
  padding: 1.25rem;
}
.att-day-grid-nested {
  background: #f9fafb;
  border-radius: 8px;
  padding: 1rem;
}
.att-day-cell {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 8px 6px;
  text-align: center;
  background: #fff;
}
.att-day-date { font-size: 15px; font-weight: 600; color: #111827; }
.att-day-name {
  font-size: 10px;
  text-transform: uppercase;
  color: #9ca3af;
  margin-bottom: 5px;
}

/* ── BADGES ── */
.att-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 500;
}
.att-badge-sm { padding: 2px 8px; font-size: 10px; }
.att-badge-present { background: #d1fae5; color: #065f46; }
.att-badge-absent { background: #fff3f3; color: #e53935; }
.att-badge-halfday { background: #fef3c7; color: #b45309; }
.att-badge-late { background: #fef3c7; color: #b45309; }
.att-badge-leave { background: #f3f4f6; color: #6b7280; }
.att-badge-holiday { background: #ede9fe; color: #6d28d9; }
.att-badge-default { background: #f3f4f6; color: #6b7280; }

/* ── RESPONSIVE ── */
@media (max-width: 720px) {
  .att-time-row { grid-template-columns: 1fr; }
  .att-stats-5 { grid-template-columns: repeat(2, 1fr); }
  .att-summary-row { flex-direction: column; }
  .att-table th:nth-child(4),
  .att-table td:nth-child(4) { display: none; }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Engineer/EngineerAttendence/EngineerAttendance.css"],"names":[],"mappings":"AAAA;;;;+CAI+C;;AAE/C;EACE,cAAc;EACd,sEAAsE;EACtE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;EACrB,gCAAgC;AAClC;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;AACA,iBAAiB,cAAc,EAAE;AACjC,kBAAkB,cAAc,EAAE,4BAA4B,EAAE;;AAEhE,kBAAkB;AAClB;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA,yBAAyB,mBAAmB,EAAE;AAC9C,4BAA4B,mBAAmB,EAAE,mBAAmB,EAAE;;AAEtE;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;AACA,uBAAuB,mBAAmB,EAAE;AAC5C,0BAA0B,YAAY,EAAE,mBAAmB,EAAE;AAC7D,cAAc,iBAAiB,EAAE,eAAe,EAAE;;AAElD;EACE,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;AACA,0BAA0B,6CAA6C,EAAE,2BAA2B,EAAE;;AAEtG,oCAAoC;AACpC;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,4BAA4B;AAC9B;AACA,uBAAuB,mBAAmB,EAAE;;AAE5C;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;AACA,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,cAAc,mBAAmB,EAAE,cAAc,EAAE;AACnD,iBAAiB,mBAAmB,EAAE,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE;;AAE3G;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,WAAW;EACX,8BAA8B;AAChC;AACA,8BAA8B,qBAAqB,EAAE,gBAAgB,EAAE;;AAEvE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;AACA,0BAA0B,qBAAqB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACtF;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,qBAAqB;EACrB,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;;;EAGE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;AACA,kBAAkB,WAAW,EAAE;;AAE/B;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;AAChB;AACA,oCAAoC,mBAAmB,EAAE;AACzD,+BAA+B,mBAAmB,EAAE;AACpD,aAAa,yBAAyB,EAAE;;AAExC;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;AACA,2BAA2B,0BAA0B,EAAE;;AAEvD,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;AACA,eAAe,qCAAqC,EAAE;AACtD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;AACA,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACrE,kBAAkB,cAAc,EAAE;AAClC,kBAAkB,cAAc,EAAE;AAClC,gBAAgB,cAAc,EAAE;;AAEhC,4CAA4C;AAC5C;EACE,aAAa;EACb,SAAS;EACT,0BAA0B;AAC5B;AACA;EACE,SAAO;EACP,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA,uBAAuB,cAAc,EAAE;AACvC,qBAAqB,cAAc,EAAE;;AAErC,iDAAiD;AACjD;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACnE;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA,gBAAgB,gBAAgB,EAAE,eAAe,EAAE;AACnD,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D,qBAAqB;AACrB;EACE,gBAAgB,0BAA0B,EAAE;EAC5C,eAAe,qCAAqC,EAAE;EACtD,mBAAmB,sBAAsB,EAAE;EAC3C;+BAC6B,aAAa,EAAE;AAC9C","sourcesContent":["/* ─────────────────────────────────────────────\n   EngineerAttendance.css\n   Self-contained styles for the attendance feature.\n   Palette matches Engineer.css (#185fa5 primary blue).\n───────────────────────────────────────────── */\n\n.att-page {\n  margin: 0 auto;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  color: #1a1a1a;\n}\n\n/* ── TOP BAR ── */\n.att-topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.25rem;\n}\n.att-page-title {\n  font-size: 22px;\n  font-weight: 600;\n  letter-spacing: -0.3px;\n  margin: 0 0 2px;\n}\n.att-page-sub {\n  font-size: 13px;\n  color: #6b7280;\n  margin: 0;\n}\n\n/* ── ROLE TABS ── */\n.att-tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 1.5rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n.att-tab {\n  background: transparent;\n  border: none;\n  border-bottom: 2px solid transparent;\n  padding: 10px 4px;\n  margin-right: 20px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #6b7280;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.att-tab:hover { color: #185fa5; }\n.att-tab.active { color: #185fa5; border-bottom-color: #185fa5; }\n\n/* ── BUTTONS ── */\n.att-btn-primary {\n  background: #185fa5;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  padding: 9px 20px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.att-btn-primary:hover { background: #0c447c; }\n.att-btn-primary:disabled { background: #93b8d8; cursor: not-allowed; }\n\n.att-btn-ghost {\n  background: transparent;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  padding: 9px 20px;\n  font-size: 13px;\n  color: #374151;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.att-btn-ghost:hover { background: #f3f4f6; }\n.att-btn-ghost:disabled { opacity: 0.6; cursor: not-allowed; }\n.att-btn-sm { padding: 6px 14px; font-size: 12px; }\n\n.att-btn-checkout {\n  background: linear-gradient(135deg, #ef8b3b, #d9631a);\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  padding: 9px 20px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.att-btn-checkout:hover { box-shadow: 0 6px 16px rgba(217, 99, 26, 0.3); transform: translateY(-1px); }\n\n/* ── CHECK-IN / CHECK-OUT CARD ── */\n.att-checkcard {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  overflow: hidden;\n  margin-bottom: 1.5rem;\n}\n.att-checkcard-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 1.25rem 1.5rem;\n  border-bottom: 1px solid #e5e7eb;\n  background: #f9fafb;\n}\n.att-checkcard-title {\n  font-size: 15px;\n  font-weight: 600;\n  margin-bottom: 2px;\n}\n.att-checkcard-sub {\n  font-size: 12.5px;\n  color: #6b7280;\n}\n.att-checkcard-body {\n  padding: 1.5rem;\n}\n.att-time-row {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  margin-bottom: 1.5rem;\n}\n.att-time-block {\n  background: #f9fafb;\n  border: 1px solid #f0f0f0;\n  border-radius: 10px;\n  padding: 14px 16px;\n}\n.att-time-label {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: #9ca3af;\n  margin-bottom: 4px;\n}\n.att-time-value {\n  font-size: 20px;\n  font-weight: 600;\n  color: #111827;\n  margin-bottom: 6px;\n}\n.att-time-loc {\n  font-size: 11.5px;\n  color: #6b7280;\n  line-height: 1.4;\n}\n.att-checkcard-actions {\n  display: flex;\n  justify-content: center;\n}\n.att-done-msg {\n  font-size: 14px;\n  font-weight: 500;\n  color: #2e7d32;\n  background: #e6f4ea;\n  border-radius: 8px;\n  padding: 10px 20px;\n}\n\n/* ── MODAL ── */\n.att-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n.att-modal {\n  background: #fff;\n  border-radius: 14px;\n  padding: 1.5rem;\n  width: 100%;\n  max-width: 420px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n}\n.att-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n}\n.att-modal-title {\n  font-size: 17px;\n  font-weight: 600;\n  margin: 0;\n}\n.att-close-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 1px solid #e5e7eb;\n  background: transparent;\n  cursor: pointer;\n  font-size: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6b7280;\n  transition: background 0.15s;\n}\n.att-close-btn:hover { background: #f3f4f6; }\n\n.att-location-block {\n  margin-bottom: 1rem;\n}\n.att-location-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 6px;\n}\n.att-location-status {\n  font-size: 13px;\n  border-radius: 8px;\n  padding: 10px 12px;\n}\n.att-loc-loading { background: #f3f4f6; color: #6b7280; }\n.att-loc-ok { background: #eff6ff; color: #185fa5; }\n.att-loc-error { background: #fff3f3; color: #e53935; display: flex; align-items: center; flex-wrap: wrap; }\n\n.att-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  margin-bottom: 1rem;\n}\n.att-form-group label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #374151;\n}\n.att-form-group input {\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  padding: 8px 11px;\n  font-size: 13px;\n  background: #f9fafb;\n  color: #111827;\n  outline: none;\n  width: 100%;\n  transition: border-color 0.15s;\n}\n.att-form-group input:focus { border-color: #185fa5; background: #fff; }\n\n.att-photo-upload {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px dashed #d1d5db;\n  border-radius: 8px;\n  padding: 16px;\n  text-align: center;\n  cursor: pointer;\n  font-size: 12px;\n  color: #6b7280;\n  background: #f9fafb;\n  transition: all 0.15s;\n  min-height: 80px;\n}\n.att-photo-upload:hover { border-color: #185fa5; color: #185fa5; background: #eff6ff; }\n.att-photo-preview {\n  max-width: 100%;\n  max-height: 220px;\n  border-radius: 6px;\n  object-fit: cover;\n}\n\n.att-modal-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 0.5rem;\n}\n\n/* ── TABLE CARDS (monthly / daily views) ── */\n.att-table-card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  overflow: hidden;\n  margin-bottom: 1.5rem;\n}\n.att-table-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n.att-table-title {\n  font-size: 15px;\n  font-weight: 600;\n}\n.att-month-picker {\n  display: flex;\n  gap: 8px;\n}\n.att-month-picker select,\n.att-year-input,\n.att-date-input {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 7px 10px;\n  font-size: 13px;\n  background: #f9fafb;\n  color: #111827;\n  outline: none;\n}\n.att-year-input { width: 90px; }\n\n.att-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.att-table th {\n  text-align: left;\n  font-size: 11px;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding: 10px 1.25rem;\n  border-bottom: 1px solid #e5e7eb;\n  background: #f9fafb;\n}\n.att-table td {\n  padding: 13px 1.25rem;\n  font-size: 13.5px;\n  border-bottom: 1px solid #f3f4f6;\n  color: #111827;\n}\n.att-table tbody tr:last-child td { border-bottom: none; }\n.att-table tbody tr:hover td { background: #f9fafb; }\n.att-muted { color: #6b7280 !important; }\n\n.att-empty {\n  text-align: center;\n  padding: 3rem;\n  font-size: 14px;\n  color: #6b7280;\n}\n\n.att-photo-links {\n  display: flex;\n  gap: 10px;\n}\n.att-photo-links a {\n  color: #185fa5;\n  font-size: 12.5px;\n  font-weight: 500;\n  text-decoration: none;\n}\n.att-photo-links a:hover { text-decoration: underline; }\n\n/* ── STAT CARDS ── */\n.att-stats {\n  display: grid;\n  gap: 12px;\n  padding: 1.25rem;\n}\n.att-stats-5 { grid-template-columns: repeat(5, 1fr); }\n.att-stat-card {\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 0.9rem 1rem;\n}\n.att-stat-label {\n  font-size: 11px;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 6px;\n}\n.att-stat-value { font-size: 24px; font-weight: 600; color: #111827; }\n.att-stat-green { color: #3b6d11; }\n.att-stat-amber { color: #b45309; }\n.att-stat-red { color: #dc2626; }\n\n/* ── SUMMARY PILLS (self monthly view) ── */\n.att-summary-row {\n  display: flex;\n  gap: 12px;\n  padding: 1.25rem 1.25rem 0;\n}\n.att-summary-pill {\n  flex: 1;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 12px 16px;\n  font-size: 12.5px;\n  color: #6b7280;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.att-summary-pill span {\n  font-size: 22px;\n  font-weight: 600;\n  color: #111827;\n}\n.att-pill-green span { color: #3b6d11; }\n.att-pill-red span { color: #dc2626; }\n\n/* ── DAY GRID (calendar-style status cells) ── */\n.att-day-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(64px, 1fr));\n  gap: 8px;\n  padding: 1.25rem;\n}\n.att-day-grid-nested {\n  background: #f9fafb;\n  border-radius: 8px;\n  padding: 1rem;\n}\n.att-day-cell {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 8px 6px;\n  text-align: center;\n  background: #fff;\n}\n.att-day-date { font-size: 15px; font-weight: 600; color: #111827; }\n.att-day-name {\n  font-size: 10px;\n  text-transform: uppercase;\n  color: #9ca3af;\n  margin-bottom: 5px;\n}\n\n/* ── BADGES ── */\n.att-badge {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 500;\n}\n.att-badge-sm { padding: 2px 8px; font-size: 10px; }\n.att-badge-present { background: #d1fae5; color: #065f46; }\n.att-badge-absent { background: #fff3f3; color: #e53935; }\n.att-badge-halfday { background: #fef3c7; color: #b45309; }\n.att-badge-late { background: #fef3c7; color: #b45309; }\n.att-badge-leave { background: #f3f4f6; color: #6b7280; }\n.att-badge-holiday { background: #ede9fe; color: #6d28d9; }\n.att-badge-default { background: #f3f4f6; color: #6b7280; }\n\n/* ── RESPONSIVE ── */\n@media (max-width: 720px) {\n  .att-time-row { grid-template-columns: 1fr; }\n  .att-stats-5 { grid-template-columns: repeat(2, 1fr); }\n  .att-summary-row { flex-direction: column; }\n  .att-table th:nth-child(4),\n  .att-table td:nth-child(4) { display: none; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
